import React, { createContext, FC, useState } from 'react'

import { ApplicationContextValue } from './ContextType'
import { ApplicationContextInitialValues } from './InitialValues'

interface Iprops {
  applicationContext: ApplicationContextValue
  setApplicationContext: (value: ApplicationContextValue) => void
}

export const ApplicationContext = createContext<Iprops>({
  applicationContext: ApplicationContextInitialValues,
  setApplicationContext: (value: ApplicationContextValue) => void 0,
})

export const ApplicationProvider: FC = ({ children }) => {
  const initialValues = window.sessionStorage.getItem('ctx')

  let initialValuesCTX: ApplicationContextValue | null = null
  if (initialValues) {
    initialValuesCTX = JSON.parse(initialValues)
  }

  const [state, setState] = useState<ApplicationContextValue>(
    initialValuesCTX || ApplicationContextInitialValues,
  )

  const updateContext = (value: ApplicationContextValue) => {
    setState(value)
    window.sessionStorage.setItem('ctx', JSON.stringify(value))
  }

  return (
    <ApplicationContext.Provider
      value={{
        applicationContext: state,
        setApplicationContext: (value: ApplicationContextValue) =>
          updateContext(value),
      }}
    >
      {children}
    </ApplicationContext.Provider>
  )
}
